import {
  EntryTypeSelect,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

export const StaticTextStandardSettings = [
  EntryTypeSelect,
  {
    label: 'Static Text',
    settingType: 'longTextInput',
    updateType: 'entry',
    property: 'label',
  },
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
